import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';

const FieldRadio = ({
  additionalAction,
  name,
  required,
  radios,
  inputLabel,
  defaultValue,
  disabled,
}) => {
  const {
    setFieldValue,
    validateForm,
    values,
    errors,
    touched,
  } = useFormikContext();
  const onChange = (e) => {
    const { value } = e.target;
    additionalAction(value, validateForm);
    setFieldValue(name, value);
  };

  useEffect(() => {
    if (defaultValue) {
      additionalAction(defaultValue, validateForm);
      setFieldValue(name, defaultValue);
    }
  }, [defaultValue]);

  return (
    <div className="field -field-radio">
      {errors[name] && touched[name] && <div className="field-invalid">{errors[name]}</div>}
      <p className="label-field mb-10">
        {inputLabel}
        {required && <span className="color-red "> * </span>}
      </p>
      <div role="group" aria-labelledby={`${name}-radio-group`}>
        {radios.map((item) => (
          <label htmlFor={item.label} key={item.value} className="input-radio">
            <Field
              id={item.label}
              type="radio"
              name={name}
              value={item.value}
              checked={values[name] === item.value}
              onChange={onChange}
              disabled={disabled} />
            <div className="label-radio">{item.label}</div>
          </label>
        ))}
      </div>
    </div>
  );
};

FieldRadio.defaultProps = {
  additionalAction: () => { },
  required: false,
  radios: [{ label: 'Si', value: 'yes' }, { label: 'No', value: 'no' }],
  defaultValue: '',
  disabled: false,
};

FieldRadio.propTypes = {
  additionalAction: PropTypes.func,
  name: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  required: PropTypes.bool,
  radios: PropTypes.array,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FieldRadio;
